export function SiteNav() {
	return (
		<nav className="site-nav">
			<a className="site-nav__name" href="#top">
				Stefanny Daniela Mora Nieto
			</a>
			<ul className="site-nav__links">
				<li><a href="#vida">Vida</a></li>
				<li><a href="#activismo">Activismo</a></li>
				<li><a href="#trayectoria">Trayectoria</a></li>
				<li><a href="#justicia">Justicia</a></li>
			</ul>
			<a className="site-nav__cta" href="#justicia">
				Exigimos justicia
			</a>
		</nav>
	);
}
